import type { MonospaceSingleRelationField, MonospaceSingleRelationFieldMeta } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

interface StudioSingleRelationField extends MonospaceSingleRelationField {
	isStudioOnly?: boolean;
}

export const SingleRelationField = withItemType<StudioSingleRelationField>().defineCollection({
	name: 'MonospaceSingleRelationField',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		defaultFields: ['id', 'apiName', 'isNullable', 'isList', 'oppositeCollectionId', 'collectionId', 'constraintId', 'oppositeRelationFieldId'],
		endpoint: 'schema/structure/fields/single-relation',
	},
});

export const SingleRelationFieldMeta = withItemType<MonospaceSingleRelationFieldMeta>().defineCollection({
	name: 'MonospaceSingleRelationFieldMeta',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => item.fieldId,
	meta: {
		defaultFields: ['fieldId', 'description', 'typeTemplateId', 'typeOptions', 'inputId', 'inputOptions', 'displayId', 'displayName', 'displayOptions', 'isHidden', 'sort', 'oppositeJunctionRelationFieldId'],
		endpoint: 'schema/meta/fields/single-relation',
		connect: {
			fieldId: ['field', 'id'],
		},
	},
});
